// extracted by mini-css-extract-plugin
export default {"formHeading":"HN-z","form":"IN-z","submitBtn":"JN-z","disabled":"KN-z","input":"LN-z","error":"MN-z","submitMsg":"NN-z","signIn":"ON-z"};